import { UPLOADS, ebook, pdf } from '@/content/ebookBuilder'
import type { Ebook } from '@/content/ebookBuilder'

export const added: Ebook = ebook(
  // Confirmed, and NOT what the title rule derives — the fifth one it has got
  // wrong. The reference screenshots for this book's page came from
  // `digitopia.co/impact-labs/ebooks/mastering-the-art-of-digital-transformation/`
  // on 2026-08-28 and carry that address in their filenames, so the slug is the
  // whole title after the colon and `from-strategy-to-success` (the part
  // before it) was a wrong guess.
  'mastering-the-art-of-digital-transformation',
  'From Strategy to Success: Mastering the Art of Digital Transformation',
  `${UPLOADS}/2025/04/FROM-STRATEGY-TO-SUCCESS-Mastering-the-Art-of-Digital-Transformation-400x400.jpg`,
  {
    confirmed: true,
    download: pdf(
      '300ca4f7-0413-410e-9fce-24e4164020b6-Mastering the Art of Digital Transformation.pdf',
    ),
    // Designed as its own written page on 2026-08-28, the seventh — so the card
    // goes there and `prerender.tsx` skips it, rather than generating this
    // template over the top of it.
    href: '/en/impact-labs/ebooks/mastering-the-art-of-digital-transformation',
  },
)

/** Its place in the library grid — the order the imported index listed them. */
export const order = 5
